import { Box, StackProps, Text, VStack } from "@chakra-ui/react";
import TabSelector from "../TabSelector";
import { useState } from "react";
import InstagramPreview from "./InstagramPreview";
import FacebookPreview from "./FacebookPreview";
import { InstagramAccount } from "../../types";
import { FacebookPage } from "../../types";

const AdPreview = (
  props: StackProps & {
    instagramAccounts?: InstagramAccount[];
    pages?: FacebookPage[];
    name?: string;
    description?: string;
  }
) => {
  const [selectedOptionId, setSelectedOptionId] = useState<string>("instagram");
  const { instagramAccounts, pages, name, description, ...stackProps } = props;
  return (
    <VStack
      textAlign={"left"}
      gap={4}
      flex={1}
      minH="full"
      bg="gray.200"
      h="full"
      w="full"
      flexGrow={1}
      p={[1, 4]}
      {...stackProps}
    >
      <TabSelector
        size="sm"
        optionId={selectedOptionId}
        onOptionChange={(optionId) => {
          setSelectedOptionId(optionId);
        }}
        options={[
          {
            id: "instagram",
            label: "Instagram",
            content: <InstagramPreview instagramAccounts={instagramAccounts} />,
          },
          {
            id: "facebook",
            label: "Facebook",
            content: (
              <FacebookPreview
                pages={pages}
                name={name}
                description={description}
              />
            ),
          },
        ]}
      />
    </VStack>
  );
};

export default AdPreview;
